const facts = [
  {
    value: "247 acres",
    label: "Total site area",
    note: "Across 21 enclosed fields (~100 hectares)",
  },
  {
    value: "173 acres",
    label: "Solar array area",
    note: "Set back from homes & roads (~70 hectares)",
  },
  {
    value: "76 MWp",
    label: "Installed capacity",
    note: "Peak generating capacity of the project",
  },
  {
    value: "~18,000",
    label: "Irish homes powered each year",
    note: "Equivalent annual electricity consumption",
  },
  {
    value: "~21,000 t",
    label: "CO₂ avoided every year",
    note: "Cleaner air across the region",
  },
  {
    value: "≈ 4,500 cars",
    label: "Diesel cars off the road",
    note: "Annual emissions equivalent",
  },
];

export default function ProjectFacts() {
  return (
    <section id="project" className="border-y border-[#E0DCD3] bg-[#F2EFE8]" data-testid="project-facts-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-10">
          <div className="md:col-span-5 reveal">
            <p className="overline mb-4">The project at a glance</p>
            <h2 className="font-serif-display text-3xl lg:text-4xl tracking-tight">
              The headline numbers.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 reveal">
            <p className="text-[15px] leading-relaxed text-[#2A2B2A]/85">
              At <strong>76 MWp</strong>, the Loughrea Solar Farm will produce
              enough clean electricity to power around{" "}
              <strong>18,000 Irish homes</strong> — every year, for decades —
              while continuing to allow low‑level grazing across most of the
              site.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E0DCD3] border border-[#E0DCD3] rounded-sm overflow-hidden">
          {facts.map((f, i) => (
            <div
              key={i}
              data-testid={`fact-${i}`}
              className="bg-[#F9F8F6] p-7 lg:p-9 hover:bg-white transition-colors"
            >
              <div className="font-serif-display text-3xl lg:text-4xl tracking-tight text-[#3A4B3A]">
                {f.value}
              </div>
              <div className="mt-3 text-[13px] font-medium text-[#2A2B2A]">{f.label}</div>
              <div className="mt-1 text-[13px] text-[#63635E]">{f.note}</div>
            </div>
          ))}
        </div>

        <p className="mt-6 text-[12px] text-[#63635E] italic max-w-3xl">
          Figures based on typical yields for Irish ground‑mounted solar
          (≈1,000 kWh per kWp installed), an average household consumption of
          4,200 kWh/yr, and the SEAI 2024 grid emissions factor for displaced
          electricity.
        </p>
      </div>
    </section>
  );
}
